import React from 'react';

/**
 * Skip to Main Content link for keyboard navigation accessibility
 * This link is hidden until focused via keyboard (Tab key)
 */
const SkipToMain = () => {
  const handleClick = (e) => {
    e.preventDefault();
    const mainContent = document.querySelector('main') || document.querySelector('[role="main"]');
    if (mainContent) {
      mainContent.focus();
      mainContent.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <a
      href="#main-content"
      onClick={handleClick}
      className="skip-to-main"
    >
      الانتقال إلى المحتوى الرئيسي
    </a>
  );
};

export default SkipToMain;
